/**
 * PURPOSE: Orquestar la configuración general de una disciplina en Winscore.
 * RESPONSIBILITIES: Cargar config_category, persistir reglas deportivas y conservar acciones administrativas existentes.
 * COLLABORATORS: ConfigForm.jsx, Config_Category.js y API legacy de configuración.
 * ROUTE: winscore/src/components/Cards/CardConfiguration/CardConfigCategoryGeneral/CardConfigCategoryGeneral2.jsx
 */
import React, { useEffect, useState } from "react";
import API_BASE_URL from "../../../../config/config.js";
import axios from "axios";
import "./CardConfigCategoryGeneral.css";

import ConfigForm from "./components/ConfigForm";
import AdminOptionsModal from "./components/AdminOptionsModal.jsx";
import FinalPhaseModal from "../../../Modals/ModalFinalPhase/FinalPhaseModal";
import ConfirmationModal from "./components/ConfirmationModal";

import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { RiAdminFill } from "react-icons/ri";
import PolylineIcon from "@mui/icons-material/Polyline";

import { getPeriodBySport } from "../../../../utils/periodSport.js";

const CardConfigCategoryGeneral2 = () => {
  const [configData, setConfigData] = useState({});
  const [grupos, setGrupos] = useState(1);
  const [fechasGrupo, setFechasGrupo] = useState(1);
  const [etapasFinal, setEtapasFinal] = useState(1);
  const [participantes, setParticipantes] = useState(0);
  const [rondas, setRondas] = useState(1);
  const [isManual, setIsManual] = useState(false);
  const [isRandom, setIsRandom] = useState(false);
  const [equipos, setEquipos] = useState({
    3: false,
    4: false,
    5: false,
    6: false,
  });
  const [state, setState] = useState(1);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [adminOpen, setAdminOpen] = useState(false);
  const [openFinalModal, setOpenFinalModal] = useState(false);
  const [participants, setParticipants] = useState([]);
  const [useAcumulado, setUseAcumulado] = useState(false); // Nuevo estado para useAcumulado
  const [useSembradoRegional, setUseSembradoRegional] = useState(false); // Nuevo estado para useSembradoRegional
  const [defaultTabLinkPublico, setDefaultTabLinkPublico] = useState(3); // Nuevo estado para defaultTabLinkPublico
  const [useCabezaGrupo, setUseCabezaGrupo] = useState(false);
  const [useColumnaDeporteIntegral, setUseColumnaDeporteIntegral] =
    useState(false);

  // Nuevos estados
  const [clasificacionPorAcumulado, setClasificacionPorAcumulado] =
    useState(false);
  const [useSanciones, setUseSanciones] = useState(false);
  const [useGoleadores, setUseGoleadores] = useState(false);
  const [configuracion_sembrado_region, setConfiguracionSembradoRegion] = useState(false)

  const { idevent, idsport } = useParams();
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    const getConfigCategory = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/config_category`, {
          idevent,
          idsport,
        });
        console.log("Config", response.data);
        const data = response.data;
        setConfigData(data);
        setState(data.state);

        setGrupos(data.nro_grupos);
        setFechasGrupo(data.nro_fechas_grupo);
        setEtapasFinal(data.nro_etapas_final);
        setParticipantes(data.nro_instituciones_participantes);
        setRondas(data.nro_rondas);
        setIsManual(data.isManual);
        setIsRandom(data.isRandom);
        setUseAcumulado(data.useAcumulado); // Cargar useAcumulado desde el backend
        setUseSembradoRegional(data.useSembradoRegional); // Cargar useSembradoRegional desde el backend
        setDefaultTabLinkPublico(data.defaultTabLinkPublico); // Cargar defaultTabLinkPublico desde el backend

        // Cargar los nuevos atributos desde el backend
        setClasificacionPorAcumulado(data.clasificacionPorAcumulado);
        setUseSanciones(data.useSanciones);
        setUseGoleadores(data.useGoleadores);

        // 2 atributos nuevos
        setUseCabezaGrupo(data.useCabezaGrupo);
        setUseColumnaDeporteIntegral(data.useColumnaDeporteIntegral);
        console.log("data", data.configuracion_sembrado_region)
        setConfiguracionSembradoRegion(data.configuracion_sembrado_region);

        const equiposArray = String(data.nro_equipos_x_grupo || "")
          .split(",")
          .map(Number);
        const nuevosEquipos = {
          3: false,
          4: false,
          5: false,
          6: false,
        };
        equiposArray.forEach((num) => {
          nuevosEquipos[num] = true;
        });
        setEquipos(nuevosEquipos);
      } catch (error) {
        console.error("Error fetching config category", error);
      }
    };

    if (idevent && idsport) {
      getConfigCategory();
    }
  }, [idevent, idsport]);

  const handleSaveFinalMatch = async ({
    participant1,
    participant2,
    nroFecha,
    tagFinal,
    idtypephase
  }) => {
    const matchData = {
      idevent: Number(idevent),
      idsport: Number(idsport),
      idtypephase: Number(idtypephase),
      idparticipant1: participant1 || null,
      idparticipant2: participant2 || null,
      nro_fecha: nroFecha,
      tag_final: tagFinal,
      state: 1,
    };

    try {
      const response = await axios.post(`${API_BASE_URL}/postmatches`, [
        matchData,
      ]);
      toast.success("Match guardado exitosamente");
      setOpenFinalModal(false);
    } catch (error) {
      toast.error("Error al guardar el match");
      console.error("Error al guardar el match", error);
    }
  };

  const handleSave = async (data) => {
    const {
      grupos,
      fechasGrupo,
      etapasFinal,
      participantes,
      rondas,
      isManual,
      isRandom,
      nroEquiposXGrupo,
      useValidacionRegional,
      useBandera,
      useAcumulado, // Recibir useAcumulado del formulario
      useSembradoRegional,
      defaultTabLinkPublico,
      clasificacionPorAcumulado, // Obtener clasificacionPorAcumulado del formulario
      useAcumuladoV2, // FTR-0065: "Tabla acumulada (nueva)" (solo deportes soportados)
      showUniformColumnsPdf, // Programación en PDF: columnas de uniforme visibles u ocultas
      useSanciones, // Obtener useSanciones del formulario
      useGoleadores, // Obtener useGoleadores del formulario
      useCabezaGrupo,
      useColumnaDeporteIntegral,
      configuracion_sembrado_region,
      sport_rules,
      nameSport,
      sport_image,
      game_format,
    } = data;

    const configData = {
      nro_grupos: grupos,
      isManual: isManual,
      isRandom: isRandom,
      nro_instituciones_participantes: participantes,
      nro_fechas_grupo: fechasGrupo,
      nro_etapas_final: etapasFinal,
      nro_rondas: rondas,
      nro_equipos_x_grupo: nroEquiposXGrupo,
      useValidacionRegional: useValidacionRegional,
      useBandera: useBandera,
      useAcumulado: useAcumulado, // Enviar useAcumulado al backend
      useSembradoRegional: useSembradoRegional,
      defaultTabLinkPublico: defaultTabLinkPublico,
      clasificacionPorAcumulado: clasificacionPorAcumulado, // Enviar clasificacionPorAcumulado al backend
      ...(useAcumuladoV2 !== undefined ? { useAcumuladoV2: Boolean(useAcumuladoV2) } : {}),
      ...(showUniformColumnsPdf !== undefined ? { showUniformColumnsPdf: Boolean(showUniformColumnsPdf) } : {}),
      useSanciones: useSanciones, // Enviar useSanciones al backend
      useGoleadores: useGoleadores, // Enviar useGoleadores al backend
      useCabezaGrupo: useCabezaGrupo,
      useColumnaDeporteIntegral: useColumnaDeporteIntegral,
      state: state,
      idevent: idevent,
      idsport: idsport,
      configuracion_sembrado_region: configuracion_sembrado_region,
      sport_rules,
      nameSport,
      sport_image,
      ...(game_format ? { game_format } : {}),
    };

    try {
      const response = await axios.patch(
        `${API_BASE_URL}/configcategory`,
        configData
      );
      toast.success("¡Configuración Guardada Exitosamente!");
      console.log("Config Category Actualizado", response.data);
      window.dispatchEvent(
        new CustomEvent("winscore:sport-identity-updated", {
          detail: {
            idevent: Number(idevent),
            idsport: Number(idsport),
            nameSport: String(nameSport || "").trim() || null,
            sport_image: String(sport_image || "").trim() || null,
          },
        })
      );
      window.dispatchEvent(
        new CustomEvent("winscore:config-category-updated", {
          detail: {
            idevent: Number(idevent),
            idsport: Number(idsport),
            state: Number(state),
            ...(useAcumuladoV2 !== undefined ? { useAcumuladoV2: Boolean(useAcumuladoV2) } : {}),
          },
        })
      );
    } catch (error) {
      toast.error("¡Configuración no se puede Guardar!");
      console.error("Error al actualizar la Config Category", error);
    }
  };

  const handleGenerarFaseFinal = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}/getparticipants`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
        idtypephase: 1,
      });
      setParticipants(response.data);
      setOpenFinalModal(true);
    } catch (error) {
      console.error("Error fetching participants:", error);
    }
  };

  const handleClose = async () => {
    try {
      const response = await axios.patch(`${API_BASE_URL}/configcategory`, {
        idevent: idevent,
        idsport: idsport,
        state: 2,
      });
      console.log("Config Category Cerrado", response.data);
      toast.success("¡Configuración Cerrada Exitosamente!");
      setState(2);
      window.dispatchEvent(
        new CustomEvent("winscore:config-category-updated", {
          detail: {
            idevent: Number(idevent),
            idsport: Number(idsport),
            state: 2,
          },
        })
      );
    } catch (error) {
      toast.error("¡Configuración no se puede Cerrar!");
      console.error("Error al cerrar la Config Category", error);
    }
  };

  const handleConfirmOpen = () => setConfirmOpen(true);
  const handleConfirmClose = () => setConfirmOpen(false);

  const handleAdminOpen = () => setAdminOpen(true);
  const handleAdminClose = () => setAdminOpen(false);

  const handleActualizarPosiciones = async () => {
    try {
      let baseUrl = (+idsport === 56 || +idsport === 57) ? 'patchposicionesrugby' : 'patchposiciones';
      // const response = await axios.patch(`${API_BASE_URL}/patchposiciones`, {
      const response = await axios.patch(`${API_BASE_URL}/${baseUrl}`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
      });
      toast.success("¡Posiciones Actualizadas Exitosamente!");
      console.log("Response", response);
    } catch (error) {
      toast.error("¡Hubo un error en la actualizacion de las Posiciones!");
      console.error("Error al actualizar las Posiciones", error);
    }
  };

  const onUpdateAcumulados = async () => {
    try {
      const response = await axios.patch(`${API_BASE_URL}/patchacumulados`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
      });
      toast.success("¡Se actualizó los acumulados!");
      console.log("Response", response);
    } catch (error) {
      toast.error("¡Hubo un error en la actualizar los Acumulados!");
      console.error("Error al actualizar las Posiciones", error);
    }
  };

  const onUpdateTablaSanciones = async () => {
    try {
      const response = await axios.patch(`${API_BASE_URL}/patchsanciones`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
        idmatch: 955
      });
      toast.success("¡Se actualizó las sanciones!");
      console.log("Response", response);
    } catch (error) {
      toast.error("¡Hubo un error en la actualizar las Sanciones!");
      console.error("Error al actualizar las Sanciones", error);
    }
  };

  const onUpdatePuntajeFinal = async() => {
    try {
      const response = await axios.post(`${API_BASE_URL}/updatepuntuacionfinal`, {
        idevent: Number(idevent),
      });
      toast.success("¡Se actualizó el Puntaje General!");
      console.log("Response", response);
    } catch (error) {
      toast.error("¡Hubo un error en la actualizar el Puntaje General!");
      console.error("Error al actualizar el Puntaje General", error);
    }
  }

  const onQualificationToFinalPhase = async() => {
    try {
      const response = await axios.post(`${API_BASE_URL}/qualificationtofinalphase`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
      })
      toast.success("¡Se actualizó la calificación a la Fase Final!");
      console.log("Response", response);
    } catch (error) {
      toast.error("Hubo un error a la calificación a la Fase Final");
      console.error("Error al actualizar la Fase Final", error);
    }
  }

  // const onUpdateAcreditados = async () => {

  //   // consultar la api de https://sismaster.perufedup.com/public/events/nominal con idevent, idsport, iduni
  //   // revisar uno por uno en accreditation por su idperson si no hay entonces armar el objeto para insertar un registro en la tabla person
  //   // después de tener el registro de person, armar un objeto para insertar un registro con ese idperson en la tabla accreditation

  //   try {
  //   } catch (error) {
  //     toast.error("¡Hubo un error en la actualizar los Acumulados!");
  //     console.error("Error al actualizar las Posiciones", error);
  //   }
  // };

  const isDisabled = state === 2;

  return (
    <div className="flex justify-center bg-gray-100 p-4">
      <div className="relative w-full max-w-5xl rounded-2xl border border-slate-200 bg-white p-5 shadow-lg sm:p-8">
        <div className="mb-6 text-center">
          <p className="text-[11px] font-black uppercase tracking-[0.2em] text-blue-600">
            Administración del deporte
          </p>
          <h2 className="mt-1 text-2xl font-black text-slate-900">
            Configuración general
          </h2>
          <p className="mt-2 text-sm text-slate-500">
            Organiza la identidad pública, estructura y reglas de la disciplina.
          </p>
        </div>
        {user?.rol === 1 && (
          <RiAdminFill
            className="absolute top-4 left-4 cursor-pointer text-blue-500 hover:text-blue-700 hover:shadow-lg transition duration-200"
            onClick={handleAdminOpen}
          />
        )}
        <PolylineIcon
          className="absolute top-4 right-4 cursor-pointer text-blue-500 hover:text-blue-700 hover:shadow-lg transition duration-200"
          onClick={handleConfirmOpen}
        />
        <ConfigForm
          configData={configData}
          isDisabled={isDisabled}
          onSave={handleSave}
          onClose={handleClose}
        />
        <ConfirmationModal
          open={confirmOpen}
          onClose={handleConfirmClose}
          onConfirmFinalPhase={handleGenerarFaseFinal}
          onUpdatePositions={handleActualizarPosiciones}
          onUpdateAcumulados={onUpdateAcumulados}
          // onUpdateTablaSanciones={onUpdateTablaSanciones}
          onUpdatePuntajeFinal={onUpdatePuntajeFinal}
          onQualificationToFinalPhase={onQualificationToFinalPhase}
        />
        <AdminOptionsModal
          open={adminOpen}
          onClose={handleAdminClose}
          equipos={equipos}
          idevent={idevent}
          idsport={idsport}
          toast={toast}
          getPeriodBySport={getPeriodBySport}
          fechasGrupo={fechasGrupo}
          configData={configData}
        />

        {openFinalModal && (
          <FinalPhaseModal
            open={openFinalModal}
            onClose={() => setOpenFinalModal(false)}
            participantes={participants}
            onSave={handleSaveFinalMatch}
          />
        )}
      </div>
    </div>
  );
};

export default CardConfigCategoryGeneral2;
